export const AVAILIABLE_PACS_QUERY_KEY = "availablePacs"
export const DRAWER_SIZE = 350
